import { Injectable } from "@angular/core";

import { SqlLanguageSpec, SqlSchema } from "../models";


@Injectable()
export class SqlEditorSchemaVisitorService {

    public findSchema(spec: SqlLanguageSpec, path: string[]): SqlSchema {
        if (!spec || !path?.length) return null;

        if (path.some(section => !section?.length)) return null;

        const schema: SqlSchema = this.findSchemaPath(spec.schemas, path);

        // If the schema was not resolved, try again considering default schema and table.
        return !!schema ? schema : this.findSchemaPathFromDefaults(spec, path);
    }

    private findSchemaPath(schemas: SqlSchema[], path: string[]): SqlSchema {
        if (!schemas?.length || !path?.length || !path[0]?.length) return null;

        // Find the schema that corresponds to this section of the path.
        const section: string = path[0].toLowerCase();

        const schema: SqlSchema = schemas.find(schema => schema.name.toLowerCase() === section);

        if (!schema) return null;

        // If this was the last section, return the schema.
        if (path.length === 1) return schema;

        // If this schema has no children resolution cannot continue.
        if (!schema.children?.length) return null;

        // Otherwise, resolve the remaining sections recursively in the descendants.
        return this.findSchemaPath(schema.children, path.slice(1));
    }

    public findSchemaPathFromDefaults(spec: SqlLanguageSpec, path: string[]): SqlSchema {
        if (!spec?.schemas?.length || !path?.length || !spec.options?.defaultSchema) return null;

        // If there is no default schema, nothing to do.
        const defaultSchema: SqlSchema = this.findSchemaPath(spec.schemas, [spec.options.defaultSchema]);

        if (!defaultSchema) return null;

        // Otherwise, try to resolve the schema starting from the default schema children.
        const schema: SqlSchema = this.findSchemaPath(defaultSchema.children, path);

        if (!!schema) return schema;

        // If it couldn't be resolved, and there is no default table, nothing to do.
        const defaultTable: SqlSchema = this.findSchemaPath(defaultSchema.children, [spec.options.defaultTable]);

        if (!defaultTable) return null;

        // Otherwise, try to resolve the schema again starting from the default table children.
        return this.findSchemaPath(defaultTable.children, path);
    }
}